import React from "react";

const LazyLeagueLeaderboard = React.lazy(
  () => import(/* webpackChunkName: "LeagueLeaderboard" */ "./leagueLeaderboard")
);

const LeagueLeaderboard = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyLeagueLeaderboard {...props} />
  </React.Suspense>
);

export default LeagueLeaderboard;
